/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_DescriptionInputs */

const en_wb_management_description = /** @type {(inputs: Wb_Management_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the priorities and owners before the brief is posted to your team.`)
};

const lv_wb_management_description = /** @type {(inputs: Wb_Management_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārbaudiet prioritātes un atbildīgos, pirms kopsavilkums tiek publicēts komandai.`)
};

/**
* | output |
* | --- |
* | "Check the priorities and owners before the brief is posted to your team." |
*
* @param {Wb_Management_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_description = /** @type {((inputs?: Wb_Management_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_description(inputs)
	return en_wb_management_description(inputs)
});